import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  user: null,
  userType: null, // NEW: 'individual' | 'business' | null
  businessSetupCompleted: false, // NEW: business setup status
  isHydrated: false, // hydration flag
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      // Extract userType and businessSetupCompleted from payload if available
      if (action.payload?.userType) {
        state.userType = action.payload.userType;
      }
      if (action.payload?.businessSetupCompleted !== undefined) {
        state.businessSetupCompleted = action.payload.businessSetupCompleted;
      }
      // ✅ FIX: Ensure userId is accessible at top level for socket registration
      if (action.payload?.userId && state.user) {
        state.user.userId = action.payload.userId;
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userType = null;
      state.businessSetupCompleted = false;
      // CRITICAL: Clear ALL storage to prevent cross-user data contamination
      if (typeof window !== 'undefined') {
        localStorage.clear(); // Clear EVERYTHING including persist:root
        sessionStorage.clear(); // Also clear session storage
      }
    },
    resetAuth: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userType = null;
      state.businessSetupCompleted = false;
    },
    setUserType: (state, action) => {
      state.userType = action.payload.userType;
      state.businessSetupCompleted = action.payload.businessSetupCompleted || false;
    },
    updateBusinessSetupStatus: (state, action) => {
      state.businessSetupCompleted = action.payload;
    },
    hydrateAuthFromStorage: (state) => {
      if (typeof window !== 'undefined') {
        try {
          const auth = localStorage.getItem('auth');
          if (auth) {
            const user = JSON.parse(auth);
            // Validate auth data - must have phone/token AND reasonable timestamp
            const isValidAuth = user && (user.token || user.phone);

            if (isValidAuth) {
              state.isLoggedIn = true;
              state.user = user;
              state.userType = user.userType || null;
              state.businessSetupCompleted = user.businessSetupCompleted || false;
            } else {
              // Invalid auth - clear it
              localStorage.removeItem('auth');
              state.isLoggedIn = false;
              state.user = null;
              state.userType = null;
              state.businessSetupCompleted = false;
            }
          } else {
            state.isLoggedIn = false;
            state.user = null;
            state.userType = null;
            state.businessSetupCompleted = false;
          }
        } catch (error) {
          console.error('[authSlice] ❌ Hydration error:', error);
          localStorage.removeItem('auth');
          state.isLoggedIn = false;
          state.user = null;
          state.userType = null;
          state.businessSetupCompleted = false;
        }
        state.isHydrated = true;
      }
    },
  },
});

export const {
  login,
  logout,
  resetAuth,
  setUserType,
  updateBusinessSetupStatus,
  hydrateAuthFromStorage,
} = authSlice.actions;
export default authSlice.reducer;
